module.exports = __webpack_public_path__ + "static/media/car.34db4a1e.svg";